import { Spinner } from '@chakra-ui/react';
import { useEffect, useState } from 'react';

import { apiSensedia } from '../../../../../services/api-sensedia';
import { CardFundsType } from '../types/MovimentacaoFundosType';
import { formatMoney } from '../utils/formatMoney';

export const CardFunds = ({
  dataCardFund,
  handleSelectFund
}: CardFundsType) => {
  let apiMf = apiSensedia;

  if (process.env.NODE_ENV != 'development') {
    apiMf = apiSensedia;
  }

  const [rntbFundo, setRntbFundo] = useState(0);
  const [rntbCDI, setRntbCDI] = useState(0);
  const [rntbIBOV, setRntbIBOV] = useState(0);

  const getDataRentabilidade = async () => {
    let looping = true;
    while (looping) {
      try {
        const res = await apiMf.get(
          `/movimentacoes-fundos/fundos/${dataCardFund.id_fundo}/rentabilidade`
        );

        const rentabilidade = res.data;

        setRntbFundo(rentabilidade.rent_12_meses);
        setRntbCDI(rentabilidade.rent_12_meses_cdi);
        setRntbIBOV(rentabilidade.rent_12_meses_ibov);

        looping = false;
      } catch (e: any) {
        if (e.response.status === 500) {
          console.log('ocorreu internal server error', e.response.statusText);
          console.log('ocorreu internal server error', e.response.data);
        } else if (e.response.status == 504) {
          console.log('ocorreu gateway timeout', e.response.data);
        }
        if (e.response.status != 504 && e.response.status != 503) {
          looping = false;
        }
      }
    }
  };

  useEffect(() => {
    getDataRentabilidade();
  }, []);

  return (
    <div className="tw-relative tw-bg-[#1C375C] tw-mt-5 tw-rounded-md tw-p-5 tw-z-20">
      <h2 className=" tw-min-h-[72px] tw-font-medium tw-text-base tw-lg:text-lg tw-leading-6 tw-text-white">
        {dataCardFund.nome_fundo}
      </h2>
      <p className="tw-font-light tw-mt-2.5 tw-text-base tw-lg:text-lg tw-leading-6 tw-text-white">
        Saldo do fundo
      </p>
      <p
        data-testid="price-fund"
        className="tw-font-light tw-mb-2.5 tw-text-base tw-lg:text-lg tw-leading-6 tw-text-orange-500"
      >
        {formatMoney(dataCardFund.saldo_fundo.toFixed(2))}
      </p>
      <hr className="tw-mt-2.5 tw-mb-2.5 tw-border-yellow-300" />
      {!rntbFundo && !rntbCDI && !rntbIBOV ? (
        <div
          data-testid="spinner"
          className="tw-w-full tw-flex tw-justify-center"
        >
          <Spinner color="#fff" size="lg" />
        </div>
      ) : (
        <>
          <p className="tw-font-light tw-text-sm tw-leading-6 tw-text-white">
            Rentabilidade Últimos 12 Meses
          </p>
          <p className="tw-font-light tw-mb-2.5 tw-text-sm tw-leading-6 tw-text-white">
            <span>Fundo {rntbFundo}%</span> <span>CDI {rntbCDI}%</span>{' '}
            <span>IBOV {rntbIBOV}%</span>
          </p>
        </>
      )}
      <hr className="tw-mt-2.5 tw-mb-5 tw-border-yellow-300" />
      <button
        disabled={!dataCardFund.available}
        className={`tw-w-full tw-h-[34px] tw-text-white tw-font-bold tw-focus:outline-none tw-focus:shadow-outline  tw-rounded-md ${
          dataCardFund.available ? 'tw-bg-[#FA6B25]' : 'tw-bg-[#828282]'
        }`}
        onClick={() => {
          handleSelectFund(dataCardFund);
        }}
      >
        {dataCardFund.available ? 'Selecionar fundo' : 'Fundo indisponível'}
      </button>
    </div>
  );
};
